module.exports = __webpack_public_path__ + "static/media/campanha_instrucoes2.8ed18993.png";